"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePatientCardsStore = exports.MEETING_TYPES = void 0;
var vuex_1 = require("vuex");
var vue_1 = require("vue");
var pinia_1 = require("pinia");
var apis_1 = require("@/constants/apis");
console.log("Initializing Pinia");
var axios_1 = require("axios");
var privilegesApi_1 = require("@/api/privilegesApi");
var messagingSender_1 = require("@/utils/messagingSender");
var appointmentApiService_1 = require("../services/appointmentApiService");
//Providers available for appointments — populated for real by loadProviders() (GetAccountProviders)
var providers = (0, vue_1.ref)([]);
// Appointments keyed by patient
var appointments = (0, vue_1.ref)([
    {
        id: 'apt-001',
        patientId: 'pt-001',
        providerId: 'prov-001',
        providerName: 'Dr. Sarah Mitchell',
        date: '2026-04-20',
        time: '10:30',
        meetingType: 'in-person',
        reason: 'Routine diabetes follow-up',
        status: 'approved',
        scheduledBy: 'provider',
        notifyEmail: true,
        notifySms: false,
        createdAt: '2026-04-01T09:00:00Z'
    },
    {
        id: 'apt-002',
        patientId: 'pt-002',
        providerId: 'prov-003',
        providerName: 'Dr. Priya Patel',
        date: '2026-04-15',
        time: '14:00',
        meetingType: 'telehealth',
        reason: 'Asthma management check-in',
        status: 'pending',
        scheduledBy: 'provider',
        notifyEmail: true,
        notifySms: true,
        createdAt: '2026-04-02T11:30:00Z'
    }
]);
exports.MEETING_TYPES = [
    { value: 'in-person', label: 'In-Person Visit', icon: 'glyphicon-user' },
    { value: 'telehealth', label: 'Telehealth (Video)', icon: 'glyphicon-facetime-video' },
    { value: 'phone', label: 'Phone Consultation', icon: 'glyphicon-earphone' },
    { value: 'follow-up', label: 'Follow-up', icon: 'glyphicon-repeat' },
    { value: 'lab-review', label: 'Lab Results Review', icon: 'glyphicon-list-alt' }
];
// Generate avatar color from name
function generateAvatarColor(name) {
    var colors = [
        '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6',
        '#ec4899', '#06b6d4', '#84cc16', '#f97316', '#6366f1'
    ];
    var hash = 0;
    for (var i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
}
exports.usePatientCardsStore = (0, pinia_1.defineStore)('patientCards', function () {
    console.log("PatientCard Store Initialized");
    // Vuex store access MUST happen at runtime (inside this function), not at module import
    var vuex = (0, vuex_1.useStore)();
    var allData = (0, vue_1.computed)(function () {
        // guard in case vuex or getters are missing during early startup
        return vuex && vuex.getters ? vuex.getters['login/getAllData'] : { manager: {}, patient: {} };
    });
    var staffContext = (0, vue_1.computed)(function () {
        var _a = (0, privilegesApi_1.resolveKeyonPrivilegeIdentity)(allData.value), accountnumber = _a.accountnumber, unique_ID = _a.unique_ID;
        return { externId: unique_ID, externId2: accountnumber };
    });
    var currentProvider = (0, vue_1.ref)({
        id: 'prov-001',
        name: 'Dr. Sarah Mitchell',
        email: 'dr.mitchell@clinic.com',
        phone: '(555) 123-4567',
        specialty: 'Internal Medicine'
    });
    var patients = (0, vue_1.ref)([]);
    /*const patients = ref<Patient[]>([
      {
        id: 'pt-001',
        pid: 1,
        accountnumber: '960059770',
        psersonalID: '958344783',
        firstName: 'James',
        lastName: 'Anderson',
        email: 'james.anderson@email.com',
        phone: '(555) 234-5678',
        address: { street: '123 Oak Street', city: 'Springfield', state: 'IL', zip: '62701' },
        dateOfBirth: '1985-03-15',
        gender: 'Male',
        socnum: '123-45-6789',
        emergency_contactn: 'Mary Anderson',
        matial_status: 'Married',
        insuranceProvider: 'Blue Cross Blue Shield',
        mrn: 'MRN-100234',
        lastVisit: '2026-04-01',
        nextAppointment: '2026-04-20',
        avatarColor: generateAvatarColor('James Anderson'),
        tags: ['Diabetes', 'Hypertension']
      },
      {
        id: 'pt-002',
        pid: 2,
        accountnumber: '960059771',
        psersonalID: '958344784',
        firstName: 'Maria',
        lastName: 'Garcia',
        email: 'maria.garcia@email.com',
        phone: '(555) 345-6789',
        address: { street: '456 Pine Avenue', city: 'Chicago', state: 'IL', zip: '60601' },
        dateOfBirth: '1972-07-22',
        gender: 'Female',
        socnum: '234-56-7890',
        emergency_contactn: 'Carlos Garcia',
        matial_status: 'Married',
        insuranceProvider: 'Aetna',
        mrn: 'MRN-100235',
        lastVisit: '2026-03-28',
        nextAppointment: '2026-04-15',
        avatarColor: generateAvatarColor('Maria Garcia'),
        tags: ['Asthma']
      },
      {
        id: 'pt-003',
        pid: 3,
        accountnumber: '960059772',
        psersonalID: '958344785',
        firstName: 'Robert',
        lastName: 'Johnson',
        email: 'robert.johnson@email.com',
        phone: '(555) 456-7890',
        address: { street: '789 Maple Drive', city: 'Evanston', state: 'IL', zip: '60201' },
        dateOfBirth: '1990-11-08',
        gender: 'Male',
        socnum: '345-67-8901',
        emergency_contactn: 'Lisa Johnson',
        matial_status: 'Single',
        insuranceProvider: 'United Healthcare',
        mrn: 'MRN-100236',
        lastVisit: '2026-04-05',
        avatarColor: generateAvatarColor('Robert Johnson'),
        tags: ['Allergies', 'Anxiety']
      },
      {
        id: 'pt-004',
        pid: 4,
        accountnumber: '960059773',
        psersonalID: '958344786',
        firstName: 'Emily',
        lastName: 'Davis',
        email: 'emily.davis@email.com',
        phone: '(555) 567-8901',
        address: { street: '321 Elm Street', city: 'Oak Park', state: 'IL', zip: '60301' },
        dateOfBirth: '1988-05-30',
        gender: 'Female',
        socnum: '456-78-9012',
        emergency_contactn: 'John Davis',
        matial_status: 'Married',
        insuranceProvider: 'Cigna',
        mrn: 'MRN-100237',
        lastVisit: '2026-03-20',
        nextAppointment: '2026-04-22',
        avatarColor: generateAvatarColor('Emily Davis'),
        tags: ['Pregnancy', 'Prenatal']
      },
      {
        id: 'pt-005',
        pid: 5,
        accountnumber: '960059774',
        psersonalID: '958344787',
        firstName: 'Michael',
        lastName: 'Wilson',
        email: 'michael.wilson@email.com',
        phone: '(555) 678-9012',
        address: { street: '654 Cedar Lane', city: 'Naperville', state: 'IL', zip: '60540' },
        dateOfBirth: '1965-09-12',
        gender: 'Male',
        socnum: '567-89-0123',
        emergency_contactn: 'Susan Wilson',
        matial_status: 'Married',
        insuranceProvider: 'Medicare',
        mrn: 'MRN-100238',
        lastVisit: '2026-04-02',
        nextAppointment: '2026-05-01',
        avatarColor: generateAvatarColor('Michael Wilson'),
        tags: ['Heart Disease', 'Diabetes', 'Hypertension']
      },
      {
        id: 'pt-006',
        pid: 6,
        accountnumber: '960059775',
        psersonalID: '958344788',
        firstName: 'Sarah',
        lastName: 'Thompson',
        email: 'sarah.thompson@email.com',
        phone: '(555) 789-0123',
        address: { street: '987 Birch Road', city: 'Schaumburg', state: 'IL', zip: '60173' },
        dateOfBirth: '1995-01-25',
        gender: 'Female',
        socnum: '678-90-1234',
        emergency_contactn: 'Tom Thompson',
        matial_status: 'Single',
        insuranceProvider: 'Blue Cross Blue Shield',
        mrn: 'MRN-100239',
        lastVisit: '2026-03-15',
        avatarColor: generateAvatarColor('Sarah Thompson'),
        // tags: ['Migraines'] // hardcoded placeholder tag - not real patient data
      },
      {
        id: 'pt-007',
        pid: 7,
        accountnumber: '960059776',
        psersonalID: '958344789',
        firstName: 'David',
        lastName: 'Martinez',
        email: 'david.martinez@email.com',
        phone: '(555) 890-1234',
        address: { street: '147 Walnut Street', city: 'Aurora', state: 'IL', zip: '60502' },
        dateOfBirth: '1978-12-03',
        gender: 'Male',
        socnum: '789-01-2345',
        emergency_contactn: 'Ana Martinez',
        matial_status: 'Married',
        insuranceProvider: 'Humana',
        mrn: 'MRN-100240',
        lastVisit: '2026-04-08',
        nextAppointment: '2026-04-25',
        avatarColor: generateAvatarColor('David Martinez'),
        tags: ['Back Pain', 'Physical Therapy']
      },
      {
        id: 'pt-008',
        pid: 8,
        accountnumber: '960059777',
        psersonalID: '958344790',
        firstName: 'Jennifer',
        lastName: 'Brown',
        email: 'jennifer.brown@email.com',
        phone: '(555) 901-2345',
        address: { street: '258 Spruce Court', city: 'Joliet', state: 'IL', zip: '60431' },
        dateOfBirth: '1982-06-18',
        gender: 'Female',
        socnum: '890-12-3456',
        emergency_contactn: 'Mike Brown',
        matial_status: 'Married',
        insuranceProvider: 'Aetna',
        mrn: 'MRN-100241',
        lastVisit: '2026-03-30',
        nextAppointment: '2026-04-18',
        avatarColor: generateAvatarColor('Jennifer Brown'),
        tags: ['Thyroid', 'Annual Checkup']
      }
    ])*/
    var searchQuery = (0, vue_1.ref)('');
    var filterTag = (0, vue_1.ref)(null);
    var sortBy = (0, vue_1.ref)('name');
    var gender = (0, vue_1.ref)('');
    // Get all unique tags
    var allTags = (0, vue_1.computed)(function () {
        var tags = new Set();
        patients.value.forEach(function (p) { return (p.tags || []).forEach(function (t) { return tags.add(t); }); });
        return Array.from(tags).sort();
    });
    // Filtered and sorted patients
    var filteredPatients = (0, vue_1.computed)(function () {
        var result = __spreadArray([], patients.value, true);
        // Search filter
        if (searchQuery.value.trim()) {
            var query_1 = searchQuery.value.toLowerCase();
            result = result.filter(function (p) {
                return p.firstName.toLowerCase().includes(query_1) ||
                    p.lastName.toLowerCase().includes(query_1) ||
                    p.email.toLowerCase().includes(query_1) ||
                    p.phone.includes(query_1) ||
                    p.mrn.toLowerCase().includes(query_1);
            });
        }
        // Tag filter
        if (filterTag.value) {
            result = result.filter(function (p) { return (p.tags || []).includes(filterTag.value); });
        }
        // Sort
        result.sort(function (a, b) {
            if (sortBy.value === 'name') {
                return "".concat(a.lastName, " ").concat(a.firstName).localeCompare("".concat(b.lastName, " ").concat(b.firstName));
            }
            else if (sortBy.value === 'lastVisit') {
                return (b.lastVisit || '').localeCompare(a.lastVisit || '');
            }
            else {
                return (a.nextAppointment || 'z').localeCompare(b.nextAppointment || 'z');
            }
        });
        return result;
    });
    function updatePatient(id, updates) {
        var index = patients.value.findIndex(function (p) { return p.id === id; });
        if (index !== -1) {
            patients.value[index] = __assign(__assign({}, patients.value[index]), updates);
        }
    }
    function getPatientById(id) {
        return patients.value.find(function (p) { return p.id === id; });
    }
    // Callers pass either the internal mid (store.patients[].id, what
    // appointments.value[].patientId is normalized to) or psersonalID (what
    // SchedulingCalendar.vue's patient <select> actually binds) — match either,
    // matching the pattern SchedulingCalendar.vue's own selectedPatient already uses.
    function findPatientByAnyId(id) {
        if (!id)
            return undefined;
        return patients.value.find(function (p) { return p.id === id || p.psersonalID === id; });
    }
    function setSearchQuery(query) {
        searchQuery.value = query;
    }
    function setFilterTag(tag) {
        filterTag.value = tag;
    }
    function setSortBy(sort) {
        sortBy.value = sort;
    }
    //appointment function added for extra functionality: 
    // Get the active (non-cancelled) appointment for a patient
    function getAppointmentForPatient(patientId) {
        return appointments.value
            .filter(function (a) { return a.patientId === patientId && a.status !== 'cancelled'; })
            .sort(function (a, b) { return "".concat(a.date, " ").concat(a.time).localeCompare("".concat(b.date, " ").concat(b.time)); })[0];
    }
    // Bulk-loads real appointments for the patients currently in `patients.value`.
    // Mirrors loadProviders()/loadPatientsFromStaffPatientsGroup() — call after patients load.
    function loadAppointmentsForPatients() {
        return __awaiter(this, void 0, void 0, function () {
            var accountnumber, selfId, rows_1, patientIds, rows, psersonalToMid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accountnumber = staffContext.value.externId2;
                        if (!accountnumber) {
                            appointments.value = [];
                            return [2 /*return*/];
                        }
                        if (!(patients.value.length === 0)) return [3 /*break*/, 2];
                        selfId = staffContext.value.externId;
                        if (!selfId) {
                            appointments.value = [];
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, (0, appointmentApiService_1.getAppointmentsForPatients)(accountnumber, [selfId])];
                    case 1:
                        rows_1 = _a.sent();
                        appointments.value = rows_1.map(function (a) {
                            var _a;
                            return (__assign(__assign({}, a), { providerName: ((_a = providers.value.find(function (p) { return p.id === a.providerId; })) === null || _a === void 0 ? void 0 : _a.name) || '' }));
                        });
                        return [2 /*return*/];
                    case 2:
                        patientIds = patients.value.map(function (p) { return p.psersonalID; }).filter(Boolean);
                        return [4 /*yield*/, (0, appointmentApiService_1.getAppointmentsForPatients)(accountnumber, patientIds)
                            // Build a reverse map psersonalID → mid so getAppointmentForPatient(patient.id)
                            // (which uses mid) can match against the fetched rows.
                        ];
                    case 3:
                        rows = _a.sent();
                        psersonalToMid = new Map();
                        patients.value.forEach(function (p) { if (p.psersonalID)
                            psersonalToMid.set(p.psersonalID, p.id); });
                        appointments.value = rows.map(function (a) {
                            var _a;
                            return (__assign(__assign({}, a), { patientId: psersonalToMid.get(a.patientId) || a.patientId, providerName: ((_a = providers.value.find(function (p) { return p.id === a.providerId; })) === null || _a === void 0 ? void 0 : _a.name) || '' }));
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function scheduleAppointment(data, notify) {
        return __awaiter(this, void 0, void 0, function () {
            var accountnumber, patientRecord, patientUniqueId, caregiverRecord, notifyPayload, res, newAppointment;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        accountnumber = staffContext.value.externId2;
                        patientRecord = findPatientByAnyId(data.patientId);
                        patientUniqueId = (patientRecord === null || patientRecord === void 0 ? void 0 : patientRecord.psersonalID) || data.patientId;
                        caregiverRecord = providers.value.find(function (p) { return p.id === data.providerId; }) || nurses.value.find(function (p) { return p.id === data.providerId; });
                        notifyPayload = notify
                            ? (0, appointmentApiService_1.buildNotifyPayload)(notify, { name: patientRecord ? "".concat(patientRecord.firstName, " ").concat(patientRecord.lastName) : '', email: (_a = patientRecord === null || patientRecord === void 0 ? void 0 : patientRecord.email) !== null && _a !== void 0 ? _a : '', phone: (_b = patientRecord === null || patientRecord === void 0 ? void 0 : patientRecord.phone) !== null && _b !== void 0 ? _b : '' }, { name: (_c = caregiverRecord === null || caregiverRecord === void 0 ? void 0 : caregiverRecord.name) !== null && _c !== void 0 ? _c : '', email: (_d = caregiverRecord === null || caregiverRecord === void 0 ? void 0 : caregiverRecord.email) !== null && _d !== void 0 ? _d : '', phone: (_e = caregiverRecord === null || caregiverRecord === void 0 ? void 0 : caregiverRecord.phone) !== null && _e !== void 0 ? _e : '' })
                            : undefined;
                        return [4 /*yield*/, (0, appointmentApiService_1.createAppointment)(accountnumber, (_g = (_f = notifyPayload === null || notifyPayload === void 0 ? void 0 : notifyPayload.notifyGroup) !== null && _f !== void 0 ? _f : data.notifyGroupMembers) !== null && _g !== void 0 ? _g : [], {
                                patientId: patientUniqueId,
                                providerId: data.providerId,
                                date: data.date,
                                time: data.time,
                                meetingType: data.meetingType,
                                reason: data.reason,
                                scheduledBy: 'provider',
                                notifyEmail: notifyPayload ? notifyPayload.notifyEmail : data.notifyEmail,
                                notifySms: notifyPayload ? notifyPayload.notifySms : data.notifySms,
                                durationMinutes: data.durationMinutes,
                                seriesId: data.seriesId
                            }, staffContext.value.externId)];
                    case 1:
                        res = _h.sent();
                        if (!res.success) {
                            return [2 /*return*/, { success: false }];
                        }
                        newAppointment = __assign(__assign({}, data), { 
                            // Normalize to the internal mid regardless of which id format the
                            // caller passed — every other appointment in the store (loaded via
                            // loadAppointmentsForPatients) is keyed this way, and callers like
                            // SchedulingCalendar.vue's patient <select> actually pass psersonalID.
                            // Without this, a freshly-booked appointment silently didn't match any
                            // patient-scoped filter (e.g. the Master Calendar) until the next reload.
                            patientId: (patientRecord === null || patientRecord === void 0 ? void 0 : patientRecord.id) || data.patientId, id: res.appointmentId || "apt-".concat(Date.now()), status: 'pending', scheduledBy: 'provider', createdAt: new Date().toISOString() });
                        appointments.value.push(newAppointment);
                        // Keep the patient's nextAppointment in sync for the card display
                        updatePatient(newAppointment.patientId, { nextAppointment: data.date });
                        return [2 /*return*/, { success: true, appointment: newAppointment }];
                }
            });
        });
    }
    function updateAppointment(id, updates, notify) {
        return __awaiter(this, void 0, void 0, function () {
            var accountnumber, existingApt, patientRecord, resolvedUpdates, caregiverId, caregiverRecord, notifyPayload, res, index, apt;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        accountnumber = staffContext.value.externId2;
                        existingApt = appointments.value.find(function (a) { return a.id === id; });
                        patientRecord = findPatientByAnyId(updates.patientId || (existingApt === null || existingApt === void 0 ? void 0 : existingApt.patientId));
                        resolvedUpdates = __assign(__assign({}, updates), { patientId: (patientRecord === null || patientRecord === void 0 ? void 0 : patientRecord.psersonalID) || updates.patientId || (existingApt === null || existingApt === void 0 ? void 0 : existingApt.patientId) });
                        caregiverId = updates.providerId || (existingApt === null || existingApt === void 0 ? void 0 : existingApt.providerId);
                        caregiverRecord = providers.value.find(function (p) { return p.id === caregiverId; }) || nurses.value.find(function (p) { return p.id === caregiverId; });
                        notifyPayload = notify
                            ? (0, appointmentApiService_1.buildNotifyPayload)(notify, { name: patientRecord ? "".concat(patientRecord.firstName, " ").concat(patientRecord.lastName) : '', email: (_a = patientRecord === null || patientRecord === void 0 ? void 0 : patientRecord.email) !== null && _a !== void 0 ? _a : '', phone: (_b = patientRecord === null || patientRecord === void 0 ? void 0 : patientRecord.phone) !== null && _b !== void 0 ? _b : '' }, { name: (_c = caregiverRecord === null || caregiverRecord === void 0 ? void 0 : caregiverRecord.name) !== null && _c !== void 0 ? _c : '', email: (_d = caregiverRecord === null || caregiverRecord === void 0 ? void 0 : caregiverRecord.email) !== null && _d !== void 0 ? _d : '', phone: (_e = caregiverRecord === null || caregiverRecord === void 0 ? void 0 : caregiverRecord.phone) !== null && _e !== void 0 ? _e : '' })
                            : undefined;
                        return [4 /*yield*/, (0, appointmentApiService_1.updateAppointment)(accountnumber, id, resolvedUpdates, staffContext.value.externId, notifyPayload)];
                    case 1:
                        res = _f.sent();
                        if (!res.success) {
                            return [2 /*return*/, { success: false }];
                        }
                        index = appointments.value.findIndex(function (a) { return a.id === id; });
                        if (index !== -1) {
                            appointments.value[index] = __assign(__assign({}, appointments.value[index]), updates);
                            apt = appointments.value[index];
                            if (updates.date) {
                                updatePatient(apt.patientId, { nextAppointment: apt.date });
                            }
                        }
                        return [2 /*return*/, { success: true }];
                }
            });
        });
    }
    function cancelAppointment(id, notify) {
        return __awaiter(this, void 0, void 0, function () {
            var accountnumber, existingApt, patientRecord, caregiverRecord, notifyPayload, res, apt;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        accountnumber = staffContext.value.externId2;
                        existingApt = appointments.value.find(function (a) { return a.id === id; });
                        patientRecord = findPatientByAnyId(existingApt === null || existingApt === void 0 ? void 0 : existingApt.patientId);
                        caregiverRecord = providers.value.find(function (p) { return p.id === (existingApt === null || existingApt === void 0 ? void 0 : existingApt.providerId); }) || nurses.value.find(function (p) { return p.id === (existingApt === null || existingApt === void 0 ? void 0 : existingApt.providerId); });
                        notifyPayload = notify
                            ? (0, appointmentApiService_1.buildNotifyPayload)(notify, { name: patientRecord ? "".concat(patientRecord.firstName, " ").concat(patientRecord.lastName) : '', email: (_a = patientRecord === null || patientRecord === void 0 ? void 0 : patientRecord.email) !== null && _a !== void 0 ? _a : '', phone: (_b = patientRecord === null || patientRecord === void 0 ? void 0 : patientRecord.phone) !== null && _b !== void 0 ? _b : '' }, { name: (_c = caregiverRecord === null || caregiverRecord === void 0 ? void 0 : caregiverRecord.name) !== null && _c !== void 0 ? _c : '', email: (_d = caregiverRecord === null || caregiverRecord === void 0 ? void 0 : caregiverRecord.email) !== null && _d !== void 0 ? _d : '', phone: (_e = caregiverRecord === null || caregiverRecord === void 0 ? void 0 : caregiverRecord.phone) !== null && _e !== void 0 ? _e : '' })
                            : undefined;
                        return [4 /*yield*/, (0, appointmentApiService_1.cancelAppointment)(accountnumber, id, staffContext.value.externId, notifyPayload)];
                    case 1:
                        res = _f.sent();
                        if (!res.success) {
                            return [2 /*return*/, { success: false }];
                        }
                        apt = appointments.value.find(function (a) { return a.id === id; });
                        if (apt) {
                            apt.status = 'cancelled';
                            updatePatient(apt.patientId, { nextAppointment: undefined });
                        }
                        return [2 /*return*/, { success: true }];
                }
            });
        });
    }
    //Axios Update Patients | Don't forget to Export this function for access 
    /** Returns true on confirmed success. On success, patches the local
     * patients entry with `updates` so the card re-renders with the new
     * values immediately - no tab switch/reload needed to see the change. */
    function axiosUpdatePatient(id, updates) {
        return __awaiter(this, void 0, Promise, function () {
            var index, content, res, e_1;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        index = patients.value.findIndex(function (p) { return p.id === id; });
                        if (index === -1)
                            return [2 /*return*/, false];
                        gender.value = updates.gender;
                        if (gender.value == "1" || gender.value == "Male") {
                            gender.value = "Male";
                        }
                        else {
                            gender.value = "Female";
                        }
                        content = {
                            UpdatePatientData: {
                                API_Meth: "Upate_Patients",
                                accountnumber: updates.accountnumber,
                                patientid: updates.psersonalID, // patientId ,
                                personalID: updates.psersonalID,
                                firstname: updates.firstName,
                                lastname: updates.lastName,
                                gender: gender.value,
                                address: (_a = updates.address) === null || _a === void 0 ? void 0 : _a.street,
                                city: (_b = updates.address) === null || _b === void 0 ? void 0 : _b.city,
                                state: (_c = updates.address) === null || _c === void 0 ? void 0 : _c.state,
                                zip: (_d = updates.address) === null || _d === void 0 ? void 0 : _d.zip,
                                emergencycontact: updates.emergency_contactn, //req
                                maritalstatus: updates.matial_status, //req
                                dob: updates.dateOfBirth, //req
                                ssnumber: updates.socnum, //req
                                phone: updates.phone, //req
                                email: updates.email, //req
                            },
                        };
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", content, {
                                headers: { "Content-Type": "application/json;" },
                            })];
                    case 2:
                        res = _h.sent();
                        if (((_e = res.data) === null || _e === void 0 ? void 0 : _e.message) === "Updated") {
                            patients.value[index] = __assign(__assign({}, patients.value[index]), updates);
                            return [2 /*return*/, true];
                        }
                        console.error("axiosUpdatePatient failed:", ((_g = (_f = res.data) === null || _f === void 0 ? void 0 : _f.errors) === null || _g === void 0 ? void 0 : _g.ErrorMessage) || res.data);
                        return [2 /*return*/, false];
                    case 3:
                        e_1 = _h.sent();
                        console.error("axiosUpdatePatient request failed:", e_1);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function loadPatientsFromStaffPatientsGroup() {
        return __awaiter(this, void 0, void 0, function () {
            var ctx, managerId, patientId, provsubaccount, content;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        ctx = staffContext.value;
                        if (!ctx.externId || !ctx.externId2) {
                            // fullPatientList.value = [];
                            patients.value = []; //I guess we are gong to say that the pateint list is here and that its empty if externId and externID2 is missing
                            return [2 /*return*/];
                        }
                        patients.value = [];
                        managerId = (_b = (_a = allData.value) === null || _a === void 0 ? void 0 : _a.patient) === null || _b === void 0 ? void 0 : _b.externId2;
                        patientId = (_d = (_c = allData.value) === null || _c === void 0 ? void 0 : _c.patient) === null || _d === void 0 ? void 0 : _d.externId;
                        provsubaccount = (_f = (_e = allData.value) === null || _e === void 0 ? void 0 : _e.manager) === null || _f === void 0 ? void 0 : _f.externid;
                        console.log("Pina Store All Data");
                        console.log(allData);
                        console.log((_g = allData.value) === null || _g === void 0 ? void 0 : _g.manager);
                        content = {
                            Patients: {
                                API_Meth: "GetPatientsFromStaffPatientsGroup",
                                accountnumber: ctx.externId2,
                                staff_unique_ID: String(ctx.externId),
                            }
                        };
                        return [4 /*yield*/, axios_1.default
                                .post(apis_1.CURR_API + "/tswebhook.php", content, {
                                headers: { "Content-Type": "application/json;" },
                            })
                                .then(function (res) {
                                console.log("Patients Payload Response");
                                console.log(res.data.patients);
                                var pts = res.data.patients && Array.isArray(res.data.patients) ? res.data.patients : [];
                                // Map and set PatientInfo
                                patients.value = pts.map(function (item) { return ({
                                    id: item.mid, //'pt-006',
                                    pid: item.patient_id, //6,
                                    accountnumber: item.accountnumber, // '960059775',
                                    psersonalID: item.patient_id, // '958344788',
                                    firstName: item.first_name, //'Sarah',
                                    lastName: item.patients_lname, //'Thompson',
                                    email: item.email, //'sarah.thompson@email.com',
                                    phone: item.contact_number, //'(555) 789-0123',
                                    address: { street: item.address, city: item.city, state: item.state, zip: item.zip },
                                    dateOfBirth: item.date_of_birth, //'1995-01-25',
                                    gender: item.gender, //'Female',
                                    socnum: item.socnum, //'678-90-1234',
                                    emergency_contactn: item.emergency_contactname, //'Tom Thompson',
                                    matial_status: item.matial_status, //'Single',
                                    insuranceProvider: 'Blue Cross Blue Shield',
                                    mrn: 'MRN-' + item.patient_id,
                                    lastVisit: item.last_visit_date || undefined,
                                    lastVisitWith: item.last_visit_with || undefined,
                                    nextAppointment: item.next_visit_date || undefined,
                                    nextAppointmentWith: item.next_visit_with || undefined,
                                    avatarColor: generateAvatarColor(item.first_name + " " + item.last_name),
                                    // tags: ['Migraines'] // hardcoded placeholder tag - not real patient data
                                }); });
                                console.log("Store Patients");
                                console.log(patients.value);
                                //now Set the Provider 
                                currentProvider.value = (0, messagingSender_1.messagingSender)(allData.value); // the signed-in person; the staff member, not the patient, while charting
                                //return patients;
                            })
                                .catch(function (err) {
                                console.log("GetPatient Error");
                                console.log(err);
                            })];
                    case 1:
                        _h.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    // Loads the real provider list for the account (used by Provider Scheduling).
    // provider_availability.provider_id is keyed off subaccountnumber, so that's
    // the id used here — not providerid/npinumber.
    // Nurse + HHA staff for the Nurse Scheduling module.
    // Populated by loadNurses() — separate from providers.
    var nurses = (0, vue_1.ref)([]);
    function loadNurses() {
        return __awaiter(this, void 0, void 0, function () {
            var ctx, rows;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctx = staffContext.value;
                        if (!ctx.externId2) {
                            nurses.value = [];
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, (0, appointmentApiService_1.getSchedulingNurseStaff)(ctx.externId2)];
                    case 1:
                        rows = _a.sent();
                        nurses.value = rows.map(function (r) { return ({
                            id: r.id,
                            name: r.name,
                            email: r.email,
                            phone: r.phone,
                            specialty: r.specialty,
                            credential: r.credential,
                            category: r.category
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    }
    function loadProviders() {
        return __awaiter(this, void 0, void 0, function () {
            var ctx, content;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctx = staffContext.value;
                        if (!ctx.externId2) {
                            providers.value = [];
                            return [2 /*return*/];
                        }
                        content = {
                            Provider: {
                                API_Meth: "GetAllAccountProviders",
                                accountnumber: ctx.externId2,
                            }
                        };
                        return [4 /*yield*/, axios_1.default
                                .post(apis_1.CURR_API + "/tswebhook.php", content, {
                                headers: { "Content-Type": "application/json;" },
                            })
                                .then(function (res) {
                                var rows = res.data.records && Array.isArray(res.data.records) ? res.data.records : [];
                                providers.value = rows
                                    .filter(function (item) { return item.subaccountnumber; })
                                    .map(function (item) { return ({
                                    id: item.subaccountnumber,
                                    name: "".concat(item.firstname || '', " ").concat(item.lastname || '').trim(),
                                    email: item.email || '',
                                    phone: item.phone1 || '',
                                    specialty: item.providerType || '',
                                    credential: item.providerType || '',
                                    category: (item.professionType === 'Allied Professional' ? 'allied' : 'provider')
                                }); });
                            })
                                .catch(function (err) {
                                console.log("GetAccountProviders Error");
                                console.log(err);
                                providers.value = [];
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        currentProvider: currentProvider,
        patients: patients,
        providers: providers,
        appointments: appointments,
        searchQuery: searchQuery,
        filterTag: filterTag,
        sortBy: sortBy,
        allTags: allTags,
        filteredPatients: filteredPatients,
        updatePatient: updatePatient,
        getPatientById: getPatientById,
        getAppointmentForPatient: getAppointmentForPatient,
        loadAppointmentsForPatients: loadAppointmentsForPatients,
        scheduleAppointment: scheduleAppointment,
        updateAppointment: updateAppointment,
        cancelAppointment: cancelAppointment,
        setSearchQuery: setSearchQuery,
        setFilterTag: setFilterTag,
        setSortBy: setSortBy,
        loadPatientsFromStaffPatientsGroup: loadPatientsFromStaffPatientsGroup,
        loadProviders: loadProviders,
        nurses: nurses,
        loadNurses: loadNurses,
        axiosUpdatePatient: axiosUpdatePatient
    };
});
